<template>
  <div class="search-input-component" :class="{ 'search-input-component--sized': !!controlHeight }" :style="sizedStyle">
    <div class="uk-search uk-search-default uk-width-1-1 position-relative">
      <span class="uk-search-icon-flip" uk-search-icon></span>
      <input
        v-model="internalValue"
        :aria-label="resolvedAriaLabel"
        :placeholder="placeholder || $t('general.search')"
        autocomplete="off"
        class="uk-search-input"
        type="search"
        @input="handleInput"
      />
      <button 
        v-if="internalValue && internalValue.length > 0" 
        @click="clearSearch"
        class="clear-search-btn"
        type="button"
      >
        <i class="uil-times"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchInput",
  props: {
    value: {
      default: ''
    },
    placeholder: {
      type: String,
      default: null
    },
    debounce: {
      type: Number,
      default: 500
    },
    controlHeight: {
      type: Number,
      default: null
    },
    ariaLabel: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      internalValue: this.value || '',
      searchTimeout: null
    };
  },
  computed: {
    resolvedAriaLabel() {
      return this.ariaLabel || this.placeholder || this.$t('general.search');
    },
    sizedStyle() {
      if (!this.controlHeight) {
        return null;
      }
      return {
        '--search-input-height': `${this.controlHeight}px`,
      };
    },
  },
  methods: {
    handleInput() {
      // Debounce ile input event'i emit et
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      
      this.searchTimeout = setTimeout(() => {
        this.$emit('input', this.internalValue);
        this.$emit('search', this.internalValue);
      }, this.debounce);
    },
    clearSearch() {
      this.internalValue = '';
      this.$emit('input', '');
      this.$emit('search', '');
    }
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal || '';
    }
  },
  beforeDestroy() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }
};
</script>

<style scoped>
.search-input-component {
  width: 100%;
}

.uk-search-input {
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  padding: 10px 40px 10px 40px;
  font-size: 14px;
  transition: all 0.3s ease;
  width: 100%;
}

.uk-search-input:focus {
  border-color: #1e87f0;
  box-shadow: 0 0 0 3px rgba(30, 135, 240, 0.1);
  outline: none;
}

.uk-search-icon-flip {
  top: 0;
  right: auto;
  left: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 100%;
  color: #999;
  z-index: 1;
  pointer-events: none;
}

.uk-search-input::placeholder {
  color: #999;
  opacity: 1;
}

.clear-search-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 2;
}

.clear-search-btn:hover {
  color: #666;
  transform: translateY(-50%) scale(1.1);
}

.clear-search-btn i {
  font-size: 16px;
}

@media (max-width: 959px) {
  .search-input-component--sized .uk-search-input {
    box-sizing: border-box;
    height: var(--search-input-height);
    min-height: var(--search-input-height);
    padding: 12px 40px 12px 48px;
    border-radius: 10px;
    font-size: 16px;
    line-height: 1.4;
  }

  .search-input-component--sized .uk-search-icon-flip {
    width: 48px;
    height: var(--search-input-height);
  }

  .search-input-component--sized .clear-search-btn {
    width: 32px;
    height: 32px;
    padding: 0;
  }

  .search-input-component--sized .clear-search-btn:active {
    transform: translateY(-50%) scale(0.98);
    opacity: 0.85;
  }
}

@media (hover: none) {
  .search-input-component--sized .clear-search-btn:hover {
    color: #999;
    transform: translateY(-50%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .search-input-component--sized .clear-search-btn:active {
    transform: translateY(-50%);
  }
}
</style>

